<template>
<div id="fastview">
<header-cont onpages="1" v-bind:buylink="buylink"></header-cont>
<!--header-->

<div class="discount wow flipInY" data-wow-delay="1.9s" v-if="isshow==1">
 <a href="javascript:;" class="close"><i></i></a>
 <a href="javascript:;" class="salebtn">
  <span>지금 얻은</span>
  <h2><i>₩</i>{{price.discountPrice}}</h2>
  <p><del>₩{{price.orgPrice}}</del> (Perpetual)</p>
 </a>
</div>
<!--discount-->

<div class="discount_pop">
 <dl>
  <dt>시간은 제한적입니다 </dt>
  <dd><i>{{zkfb}}%</i> OFF</dd>
 </dl>
 <div class="con">
  <div class="pic"><img src="../../static/images/book.png"></div>
  <ul>
   <li><h2><i>$</i>{{price.discountPrice}}</h2></li>
   <li><p><del>${{price.orgPrice}}</del> (Perpetual)</p></li>
   <li><a :href="downlink" class="btnicon"><i></i><em>Buy Now</em></a></li>
  </ul>
 </div>
</div>
<!--discount_pop-->


<div class="bigbg">
 <h1 class="wow bounceIn" data-wow-delay="0.4s">DWG FastView Plus</h1>
 <div class="con">
  <div class="pic wow fadeInLeftSmall"  data-wow-delay="0.8s"><img src="../../static/images/banner.gif"></div>
  <div class="txt wow fadeInRightSmall"  data-wow-delay="0.9s">
   <h2 class="wow fadeInRightSmall" data-wow-delay="1s">빠른 보기 & 유연한 측정 & 간편한 공유</h2>
   <p class="wow fadeInRightSmall" data-wow-delay="1.1s">CAD 소프트웨어가 필요 없는 DWG 파일 </p>
   <span  class="wow fadeInRightSmall" data-wow-delay="1.2s"><a href="https://www.youtube.com/watch?v=gDcVXpO6XV4" target="_blank"><i></i>DWG FastView Plus 제품소개 보기</a></span>
   <div class="btn wow fadeInRightSmall" data-wow-delay="1.3s"><a href="javascript:;" class="n1 btnicon downlinkMar"><i></i><em>무료 사용</em></a><a :href="downlink" class="n2 btnicon"><i></i><em>지금 구매</em></a></div>
  </div>
 </div>
</div>
<!--bigbg-->


<div class="dwg mainbox or">
 <div class="top or">
  <h2 class="wow fadeInUpSmall">DWG FastView Plus</h2>
  <p class="wow fadeInUpSmall">간단한 인터페이스와 도구를 갖춘 가장 가볍고 사용하기 쉬운 뷰어
프로그램으로, DWG/DXF 파일을 빠르고 편리하게 확인하고, 측정 및 출력, 공유를 할 수 있습니다. </p>
  <a href="Learn-more.html" class="wow fadeInUpSmall">자세히 보기</a>
 </div>
<!--top-->
 <div class="bottom or">
  <dl class="wow fadeInUpSmall" data-wow-delay="0s">
   <dt><img src="../../static/images/dwgfast_03.png"></dt>
   <dd><h3>빠르고 가벼운 뷰어</h3></dd>
   <dd>AutoCAD 2018에서 저장된 도면을 지원합니다.
몇 초 안에 대용량 파일을 열 수 있습니다.
별도의 교육없이 쉽게 사용할 수 있습니다.</dd>
  </dl>
  <dl class="wow fadeInUpSmall" data-wow-delay="0.2s">
   <dt><img src="../../static/images/dwgfast_05.png"></dt>
   <dd><h3>뷰어 이상의 기능</h3></dd>
   <dd>고급 측정 및 치수 도구는 팀 커뮤니케이션 및 데이터 교환을 향상시킵니다.</dd>
  </dl>
  <dl class="wow fadeInUpSmall last" data-wow-delay="0.3s">
   <dt><img src="../../static/images/dwgfast_07.png"></dt>
   <dd><h3>안전한 도면 공유</h3></dd>
   <dd>혁신적이고 안전하며 신뢰할 수 있는 방식으로 도면 데이터를 파트너와 공유하십시오.</dd>
  </dl>
 </div>
 <!--bottom-->
</div>
<!--dwg-->
<div class="cl"></div>

<div class="measure or">
 <div class="mainbox">
  <div class="tab wow fadeInLeftSmall">
   <a href="javascript:;" class="active">측정</a>
   <a href="javascript:;">치수</a>
   <a href="javascript:;">DWG 변환</a>
   <a href="javascript:;">도면층 제어</a>
   <a href="javascript:;">도면 비교</a>
   <a href="javascript:;">출력과 쉬운 공유</a>
  </div>

  <div class="measure_con wow fadeInRightSmall">
   <div class="list">
    <h2><i><img src="../../static/images/dwgfast_13.png"></i>측정</h2>
    <p>거리 및 각도와 같은 정확한 정보를 2D 도면에서 빠르고 직관적으로 얻을 수 있습니다.</p>
    <div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/MEASURE.mp4"><img src="../../static/images/Measure.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/dimension.png"></i>치수</h2>
    <p>선형, 정렬, 각도 등 가장 표준적인 치수 지정 도구를 사용하여, 명확하고 정확하게 측정 된 도면을 작성하십시오.</p>
    <div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/DIMENSION.mp4"><img src="../../static/images/Demension.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/convert.png"></i>DWG 변환</h2>
    <p>선택한 도면 파일 중, 하나 또는 여러 개를 사용 가능한 다른 DWG 버전으로 변환합니다.</p>
    <div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/DWG CONVERT.mp4"><img src="../../static/images/DWGCONVERT.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/layercontrol.png"></i>도면층 제어</h2>
    <p>도면층의 가시성을 제어하고 특성 팔레트를 통해 객체 특성을 관리합니다.</p>
    <div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/Layers Control.mp4"><img src="../../static/images/controlmanage.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/compare.png"></i>도면 비교</h2>
    <p>DWG 파일을 비교하고 제거, 추가 또는 수정 된 도면 요소
간의 차이점을 강조하여 표시합니다.</p>
    <div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/Compare Drawing.mp4"><img src="../../static/images/comparefiles.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/print&share.png"></i>출력과 쉬운 공유</h2>
    <p>종이로 출력하거나 PDF, PNG 형식으로 내보낼 수 있으며, 도면을 안전한고 편리하게 공유 또는 이메일로 전달할 수 있습니다. </p>
    <div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/PRINT AND SHARE.mp4"><img src="../../static/images/Print.jpg"><em></em></a></div>
   </div>
  </div>
  <!--measure_con-->
 </div>
 <!--mainbox-->
</div>
 <!--measure-->

 <div class="seewhat mainbox">
  <h2 class="wow fadeInUpSmall" data-wow-delay="0s">사용자 평가 확인<span>DWG FastView Plus</span></h2>
  <div class="con">
   <div v-for="(item,index) in ReviewList" class="list wow fadeInUpSmall" data-wow-delay="0s">
    <a href="review.html">
     <p>{{item.content}}</p>
     <div class="bottom" v-bind:style="item.backcolor">
      <dl>
       <dt><div class="reavwname">{{item.nameone}}</div></dt>
       <dd><h3>{{item.name}}</h3>{{item.country}}</dd>
      </dl>
      <span>MORE</span>
     </div>
    </a>
   </div>


  </div>
  <!--con-->
  <div class="cl"></div>

  <div class="write wow fadeInUpSmall" data-wow-delay="0.4s"><span><a href="review_add.html" class="btnicon"><i></i><em>리뷰 작성</em></a></span></div>

 </div>
 <!--seewhat-->

  <footer-cont v-bind:buylink="buylink"></footer-cont>
 <!--底部结束-->
 <!--侧边栏-->
 <ul class="side-bar slideInRight">
  <li class="s1"><a href="https://www.facebook.com/DWG-FastView-Plus-968128393349711/" target="_blank"><i></i></a></li>
  <li class="s2"><a href="https://twitter.com/Gstarsoft_CAD" target="_blank"><i></i></a></li>
  <li class="s3"><a href="https://www.youtube.com/channel/UCtYObLC_uoUtObVFx71Tn9w" target="_blank"><i></i></a></li>
 </ul>





 </div>
</template>


<script>
	export default {
	  name: 'fastview',
	  data () {
		return {
		    id:1,
			LanguageList:[],  //语言列表
			ReviewList:[],   //评论列表
			bit:'32',          // 下载 选择的 bit
			checkedlang:'韩语',  // 下载选择的语言版本
			checkedlangval:'kr',  // 下载选择的语言版本
			Colunmlist:[],        //栏目列表
			price:[],
			downlink:'',
			buylink:'',
			zkfb:'',
			isshow:1
		}
	  },
	  created:function(){

		this.Getlanage();
		this.GetReview();
		this.Getcolunmlist();
		this.getprice();
		this.getkey();

	},

	methods:{

		//获取语言
		Getlanage:function(){
		    var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchLanguage',
			  data: {productId:ProductId,pageNo:0,pageSize:5},
			  'Content-Type':"application/json",
			  success:function(res){
				  fastview.LanguageList = res.bizData.list;
			  }
		  })
		},

		//获取seo
		getkey:function(){

		  var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchSEO',
			  data: {productId:ProductId,pageCode:'index_kr'},
			  'Content-Type':"application/json",
			  success:function(res){
          console.log(res.bizData.list.length);
          if(res.bizData.list.length>0){
            document.title = res.bizData.list[0].title;
            var metas = document.getElementsByTagName("meta");
            metas[6].content = res.bizData.list[0].keywords;
            metas[7].content= res.bizData.list[0].description;
          }
			  }
		  })

		},

		//获取评价
		GetReview:function(){
		    var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchReviewList',
			  data: {productId:ProductId,pageNo:0,pageSize:4},
			  'Content-Type':"application/json",
			  success:function(res){
				  $.each(res.bizData.list,function(i,v){
					  var backcolor;
					  if(i==0){
						  backcolor = 'backgroundColor:#4488c4';
					  }
					  if(i==1){
						  backcolor = 'backgroundColor:#e29c69';
					  }
					  if(i==2){
						  backcolor = 'backgroundColor:#52afbf';
					  }
					  if(i==3){
						  backcolor = 'backgroundColor:#898ec1';
					  }
					  res.bizData.list[i].backcolor = backcolor;
                      res.bizData.list[i].nameone = res.bizData.list[i].name.charAt(0);

				  })
				  fastview.ReviewList = res.bizData.list;
			  }
		  })
		},

		//下载
		Getdownlink:function(){
			var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/downInstallPackage ',
			  data: {productId:ProductId,versionId:'1',lang:this.checkedlangval,bit:this.bit},
			  'Content-Type':"application/json",
			  success:function(res){

			  }
		   })

		},

		//获取栏目
		Getcolunmlist:function(){
			var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchContent ',
			  data: {productId:ProductId,channelCode:'case',lang:'kr',pageNo:0,pageSize:3},
			  'Content-Type':"application/json",
			  success:function(res){
				  //console.log(res);
			  }
		   })

		},

		//获取版本价格 buy 链接
		getprice:function(){
			var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/getProductPrice',
			  data: {productId:ProductId,versionId:'1',lang:'kr'},
			  'Content-Type':"application/json",
			  success:function(res){


				  fastview.$nextTick(function(){
					 $(".loaded").hide();
				  })

				  fastview.price = res.bizData;

				  fastview.zkfb = parseInt(((res.bizData.orgPrice - res.bizData.discountPrice)/res.bizData.orgPrice * 100).toFixed(2));

				  fastview.downlink = res.bizData.saleUrl;
				  fastview.buylink = res.bizData.saleUrl;
				  if(res.bizData.discountPrice==res.bizData.orgPrice){

					 fastview.isshow = 0;

				  }

			  }
		   })

		},






	}


	}


</script>




// WEBPACK FOOTER //
// src/kr/index.vue